import React from "react";
import { NavLink } from "react-router-dom";
import logoMark from "../../../assets/logo-mark.png"

export const NavBarBrand: React.FC = () => {
  return (
    <div className="nav-bar__brand">
      <NavLink to="/" className="nav-bar__brand-link">
        <img
          className="nav-bar__logo"
          src={logoMark}
          alt="Strongifier Logo"
        />
        <span className="nav-bar__wordmark">STRONGIFIER</span>
      </NavLink>
    </div>
  );
};
